import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { logger as E } from "../../shared-lib/index.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import { BRAZE_ACTIONS as oo, getDecodedBrazeAction as eo } from "../util/braze-actions.js";
import ro from "../util/browser-detector.js";
import { OperatingSystems as so } from "../util/device-constants.js";
import { BRAZE_ACTION_URI_REGEX as to, isValidBrazeActionJson as io } from "../util/validation-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { getUser as ao } from "./get-user.js";
export function _handleBrazeAction(o, e, s) {
  if (r.rr()) if (to.test(o)) {
    var _e = eo(o);
    if (!_e) return;
    var _s = function _s(o) {
      if (!io(o)) return void E.error("Decoded Braze Action json is invalid: ".concat(JSON.stringify(o, null, 2)));
      var e = oo.properties.type,
        t = oo.properties.eo,
        i = oo.properties.so,
        n = o[e];
      if (n === oo.types.io) {
        var _e2 = o[t];
        var _iterator = _createForOfIteratorHelper(_e2),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _o = _step.value;
            _s(_o);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _e3 = o[i];
        var _s2, _t;
        switch (n) {
          case oo.types.logCustomEvent:
            import("./log-custom-event.js").then(function (_ref) {
              var logCustomEvent = _ref.logCustomEvent;
              r.ao() ? (_t = Array.prototype.slice.call(_e3), logCustomEvent.apply(void 0, _toConsumableArray(_t))) : E.error(w);
            });
            break;
          case oo.types.requestPushPermission:
            import("../Push/request-push-permission.js").then(function (_ref2) {
              var requestPushPermission = _ref2.requestPushPermission;
              r.ao() ? "Safari" === ro.browser && ro.OS === so.co ? window.navigator.standalone && requestPushPermission() : requestPushPermission() : E.error(w);
            });
            break;
          case oo.types.setEmailNotificationSubscriptionType:
          case oo.types.setPushNotificationSubscriptionType:
          case oo.types.setCustomUserAttribute:
          case oo.types.addToSubscriptionGroup:
          case oo.types.removeFromSubscriptionGroup:
          case oo.types.addToCustomAttributeArray:
          case oo.types.removeFromCustomAttributeArray:
            if (_s2 = ao(), _s2) {
              var _s3;
              (_s3 = _s2)[n].apply(_s3, _toConsumableArray(Array.prototype.slice.call(_e3)));
            }
            break;
          case oo.types.mo:
          case oo.types.uo:
            _t = Array.prototype.slice.call(_e3), no.openUri.apply(no, _toConsumableArray(_t));
            break;
          default:
            E.info("Ignoring unknown Braze Action: ".concat(n));
        }
      }
    };
    _s(_e);
  } else no.openUri(o, e, s);
}
export function handleBrazeAction(o, e) {
  _handleBrazeAction(o, e);
}